import { render, staticRenderFns } from "./MySubmission.vue?vue&type=template&id=70d4b422&scoped=true&"
import script from "./MySubmission.vue?vue&type=script&lang=js&"
export * from "./MySubmission.vue?vue&type=script&lang=js&"
import style0 from "./MySubmission.vue?vue&type=style&index=0&id=70d4b422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d4b422",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VFileInput,VForm,VIcon,VProgressCircular,VRow,VSelect})
